// export default function InformationSection() {
//   return (
//     <div className="bg-white rounded-lg shadow-md p-8 mb-8 border border-[#E5E5E5]">
//       <div className="flex flex-col">
//         <h2 className="text-xl font-bold mb-4 text-[#1D3557]">
//           {`Here's how our loan repayment works:`}
//         </h2>
//         <p className="mb-4 text-[#1D3557]">
//           <strong className="text-[#4FA0FF]">Flexible Options: </strong>We offer
//           a range of repayment tenures, allowing you to choose a period that
//           aligns with your financial capacity. Whether you prefer to clear your
//           debt quickly or opt for smaller monthly installments, we have options
//           to suit your needs.
//         </p>
//         <p className="mb-4 text-[#1D3557]">
//           <strong className="text-[#4FA0FF]">EMI Calculation:</strong>{" "}
//           {`Our Equated Monthly Installment
//           (EMI) calculator helps you determine the exact amount you'll repay
//           each month. This transparency enables you to plan your finances
//           effectively.`}
//         </p>
//         <p className="mb-4 text-[#1D3557]">
//           <strong className="text-[#4FA0FF]">Auto-Debit Facility:</strong> To
//           ensure you never miss a payment, we offer an auto-debit facility. Your
//           EMI amount is automatically deducted from your linked bank account,
//           giving you peace of mind.
//         </p>
//         <p className="mb-4 text-[#1D3557]">
//           <strong className="text-[#4FA0FF]">Online Payment:</strong> We provide
//           a secure online platform for you to make your EMI payments
//           conveniently. Say goodbye to long queues and enjoy the ease of digital
//           transactions.
//         </p>
//         <p className="mb-4 text-[#1D3557]">
//           <strong className="text-[#4FA0FF]">Timely Reminders:</strong> We send
//           you timely reminders before your EMI due date, helping you stay on top
//           of your repayment schedule.
//         </p>
//         <p className="mb-4 text-[#1D3557]">
//           <strong className="text-[#4FA0FF]">No Hidden Charges:</strong>{" "}
//           {`Our commitment to transparency
//           means you won't encounter any hidden charges. The amount you agree
//           upon during the loan approval process is what you'll repay – no
//           surprises.`}
//         </p>
//       </div>

//       <div className="flex flex-col mt-8">
//         <h2 className="text-xl font-bold mb-4 text-[#1D3557]">
//           What is the maximum and minimum repayment period at Salarymates?
//         </h2>
//         <p className="text-[#1D3557]">
//           {`At Salarymates, we allow you enough time and flexibility to repay
//           your loan. This is done to ensure that repayments don't feel like
//           a burden. However, when it comes to the precise duration, the
//           minimum repayment period is 60 days, and the maximum repayment
//           period is 90 days.`}
//         </p>
//       </div>
//     </div>
//   );
// }
import React from "react";
import { motion } from "framer-motion";

export default function InformationSection() {
  // Stagger children animations
  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.25, 0.1, 0, 1] },
    },
  };

  // Generate random positions for bubbles
  const bubbles = [...Array(12)].map((_, i) => ({
    id: i,
    size: Math.random() * 10 + 4,
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    delay: i * 0.15,
    duration: Math.random() * 12 + 15,
    opacity: Math.random() * 0.1 + 0.03,
  }));

  return (
    // <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 mb-8 border border-gray-100 relative overflow-hidden">
    //   {/* Floating Elements */}
    //   <div className="absolute inset-0 pointer-events-none">
    //     <motion.div
    //       animate={{
    //         y: [0, -30, 0],
    //         x: [0, 20, 0],
    //       }}
    //       transition={{ duration: 20, repeat: Infinity }}
    //       className="absolute -top-10 -right-10 w-40 h-40 bg-[#105840]/5 rounded-full blur-3xl"
    //     />
    //     <motion.div
    //       animate={{
    //         y: [0, 30, 0],
    //         x: [0, -20, 0],
    //       }}
    //       transition={{ duration: 18, repeat: Infinity }}
    //       className="absolute -bottom-10 -left-10 w-40 h-40 bg-[#105840]/5 rounded-full blur-3xl"
    //     />
    //   </div>

    //   {/* Floating Bubbles */}
    //   <div className="absolute inset-0 overflow-hidden pointer-events-none">
    //     {bubbles.map((bubble) => (
    //       <motion.div
    //         key={bubble.id}
    //         className="absolute rounded-full bg-[#105840]"
    //         style={{
    //           width: bubble.size,
    //           height: bubble.size,
    //           left: bubble.left,
    //           top: bubble.top,
    //           opacity: bubble.opacity,
    //         }}
    //         animate={{
    //           y: [0, -40, 0, 40, 0],
    //           x: [0, 30, -30, 20, 0],
    //           scale: [1, 1.3, 0.9, 1.2, 1],
    //         }}
    //         transition={{
    //           duration: bubble.duration,
    //           repeat: Infinity,
    //           delay: bubble.delay,
    //           ease: "easeInOut",
    //         }}
    //       />
    //     ))}
    //   </div>

    //   <motion.div
    //     variants={staggerContainer}
    //     initial="hidden"
    //     whileInView="visible"
    //     viewport={{ once: true, amount: 0.1 }}
    //     className="relative z-10"
    //   >
    //     {/* Section 1: How Loan Repayment Works */}
    //     <motion.div variants={fadeInUp} className="flex flex-col">
    //       {/* Green Line Above Heading - Only above heading text */}
    //       <div className="flex items-center gap-3 mb-4">
    //         <motion.div
    //           initial={{ width: 0 }}
    //           whileInView={{ width: "40px" }}
    //           transition={{ duration: 0.8 }}
    //           className="h-1 bg-[#105840] rounded-full"
    //         />
    //         <span className="text-xs font-medium text-[#105840] tracking-wider">
    //           REPAYMENT PROCESS
    //         </span>
    //       </div>

    //       <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900">
    //         Here's how our{" "}
    //         <span className="text-[#105840]">loan repayment</span> works:
    //       </h2>

    //       <div className="space-y-5">
    //         <motion.p
    //           variants={fadeInUp}
    //           className="text-gray-700 leading-relaxed"
    //         >
    //           <strong className="text-[#105840] text-lg font-semibold">
    //             Flexible Options:{" "}
    //           </strong>
    //           We offer a range of repayment tenures, allowing you to choose a
    //           period that aligns with your financial capacity. Whether you
    //           prefer to clear your debt quickly or opt for smaller monthly
    //           installments, we have options to suit your needs.
    //         </motion.p>

    //         <motion.p
    //           variants={fadeInUp}
    //           className="text-gray-700 leading-relaxed"
    //         >
    //           <strong className="text-[#105840] text-lg font-semibold">
    //             EMI Calculation:
    //           </strong>{" "}
    //           Our Equated Monthly Installment (EMI) calculator helps you
    //           determine the exact amount you'll repay each month. This
    //           transparency enables you to plan your finances effectively.
    //         </motion.p>

    //         <motion.p
    //           variants={fadeInUp}
    //           className="text-gray-700 leading-relaxed"
    //         >
    //           <strong className="text-[#105840] text-lg font-semibold">
    //             Auto-Debit Facility:
    //           </strong>{" "}
    //           To ensure you never miss a payment, we offer an auto-debit
    //           facility. Your EMI amount is automatically deducted from your
    //           linked bank account, giving you peace of mind.
    //         </motion.p>

    //         <motion.p
    //           variants={fadeInUp}
    //           className="text-gray-700 leading-relaxed"
    //         >
    //           <strong className="text-[#105840] text-lg font-semibold">
    //             Online Payment:
    //           </strong>{" "}
    //           We provide a secure online platform for you to make your EMI
    //           payments conveniently. Say goodbye to long queues and enjoy the
    //           ease of digital transactions.
    //         </motion.p>

    //         <motion.p
    //           variants={fadeInUp}
    //           className="text-gray-700 leading-relaxed"
    //         >
    //           <strong className="text-[#105840] text-lg font-semibold">
    //             Timely Reminders:
    //           </strong>{" "}
    //           We send you timely reminders before your EMI due date, helping you
    //           stay on top of your repayment schedule.
    //         </motion.p>

    //         <motion.p
    //           variants={fadeInUp}
    //           className="text-gray-700 leading-relaxed"
    //         >
    //           <strong className="text-[#105840] text-lg font-semibold">
    //             No Hidden Charges:
    //           </strong>{" "}
    //           Our commitment to transparency means you won't encounter any
    //           hidden charges. The amount you agree upon during the loan approval
    //           process is what you'll repay – no surprises.
    //         </motion.p>
    //       </div>
    //     </motion.div>

    //     {/* Divider with decorative element */}
    //     <motion.div variants={fadeInUp} className="relative my-10">
    //       <div className="absolute inset-0 flex items-center">
    //         <div className="w-full border-t border-gray-200"></div>
    //       </div>
    //       <div className="relative flex justify-center">
    //         <span className="bg-white px-4 text-sm text-gray-400">
    //           <svg
    //             className="w-6 h-6 text-[#105840]/30"
    //             fill="currentColor"
    //             viewBox="0 0 24 24"
    //           >
    //             <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    //           </svg>
    //         </span>
    //       </div>
    //     </motion.div>

    //     {/* Section 2: Repayment Period */}
    //     <motion.div variants={fadeInUp} className="flex flex-col mt-4">
    //       {/* Green Line Above Heading - Only above heading text */}
    //       <div className="flex items-center gap-3 mb-4">
    //         <motion.div
    //           initial={{ width: 0 }}
    //           whileInView={{ width: "40px" }}
    //           transition={{ duration: 0.8 }}
    //           className="h-1 bg-[#105840] rounded-full"
    //         />
    //         <span className="text-xs font-medium text-[#105840] tracking-wider">
    //           REPAYMENT TENURE
    //         </span>
    //       </div>

    //       <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900">
    //         What is the maximum and minimum{" "}
    //         <span className="text-[#105840]">repayment period</span> at
    //         Salarymates?
    //       </h2>

    //       <motion.p
    //         variants={fadeInUp}
    //         className="text-gray-700 leading-relaxed text-lg"
    //       >
    //         At Salarymates, we allow you enough time and flexibility to repay
    //         your . This is done to ensure that repayments don't feel like a
    //         burden. However, when it comes to the precise duration, the
    //         <strong className="text-[#105840]">
    //           {" "}
    //           minimum repayment period is 60 days
    //         </strong>
    //         , and the
    //         <strong className="text-[#105840]">
    //           {" "}
    //           maximum repayment period is 90 days
    //         </strong>
    //         .
    //       </motion.p>
    //     </motion.div>

    //     <style jsx>{`
    //       @keyframes pulse {
    //         0%,
    //         100% {
    //           opacity: 0.5;
    //           transform: scale(1);
    //         }
    //         50% {
    //           opacity: 0.8;
    //           transform: scale(1.05);
    //         }
    //       }
    //       .animate-pulse {
    //         animation: pulse 2s ease-in-out infinite;
    //       }
    //     `}</style>
    //   </motion.div>
    // </div>
    <div className="bg-[#1A2F3A] rounded-2xl shadow-xl p-6 md:p-8 mb-8 border border-[#2D5F7A]/30 relative overflow-hidden">
      {/* Static Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#2D5F7A]/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-[#7BC4E0]/10 rounded-full blur-3xl" />
      </div>

      {/* Static Bubbles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {bubbles.map((bubble) => (
          <div
            key={bubble.id}
            className="absolute rounded-full bg-[#7BC4E0]"
            style={{
              width: bubble.size,
              height: bubble.size,
              left: bubble.left,
              top: bubble.top,
              opacity: bubble.opacity,
            }}
          />
        ))}
      </div>

      <div className="relative z-10">
        {/* Section 1: How Funds Repayment Works */}
        <div className="flex flex-col">
          {/* Blue Line Above Heading */}
          <div className="flex items-center gap-3 mb-4">
            <div className="w-[40px] h-1 bg-[#7BC4E0] rounded-full" />
            <span className="text-xs font-medium text-[#7BC4E0] tracking-wider">
              REPAYMENT PROCESS
            </span>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white">
            Here's how our{" "}
            <span className="text-[#7BC4E0]">Funds repayment</span> works:
          </h2>

          <div className="space-y-5">
            <p className="text-[#CCE6F5] leading-relaxed">
              <strong className="text-[#7BC4E0] text-lg font-semibold">
                One-Time Repayment:{" "}
              </strong>
              We keep it simple — your full due amount is settled in a single
              payment on your repayment date. There's no EMI or
              installment schedule to keep track of.
            </p>

            <p className="text-[#CCE6F5] leading-relaxed">
              <strong className="text-[#7BC4E0] text-lg font-semibold">
                Need More Time?
              </strong>{" "}
              We don't break your repayment into EMIs. If you need longer,
              you can instead apply for a reloan at a higher amount, giving
              you more room to manage your repayment.
            </p>

            <p className="text-[#CCE6F5] leading-relaxed">
              <strong className="text-[#7BC4E0] text-lg font-semibold">
                Online Payment:
              </strong>{" "}
              Settle your dues from anywhere through our secure payment
              gateway — no branch visits, no queues, just a few taps.
            </p>

            <p className="text-[#CCE6F5] leading-relaxed">
              <strong className="text-[#7BC4E0] text-lg font-semibold">
                Timely Reminders:
              </strong>{" "}
              We'll notify you well ahead of your repayment date, so it never
              catches you off guard.
            </p>

            <p className="text-[#CCE6F5] leading-relaxed">
              <strong className="text-[#7BC4E0] text-lg font-semibold">
                No Hidden Charges:
              </strong>{" "}
              Our commitment to transparency means you won't encounter any
              hidden charges. The amount you agree upon during the funds approval
              process is what you'll repay – no surprises.
            </p>
          </div>
        </div>

        {/* Divider with decorative element */}
        <div className="relative my-10">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-[#2D5F7A]/30"></div>
          </div>
          <div className="relative flex justify-center">
            <span className="bg-[#1A2F3A] px-4 text-sm text-gray-400">
              <svg
                className="w-6 h-6 text-[#7BC4E0]/30"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
            </span>
          </div>
        </div>

        {/* Section 2: Repayment Period */}
        <div className="flex flex-col mt-4">
          {/* Blue Line Above Heading */}
          <div className="flex items-center gap-3 mb-4">
            <div className="w-[40px] h-1 bg-[#7BC4E0] rounded-full" />
            <span className="text-xs font-medium text-[#7BC4E0] tracking-wider">
              REPAYMENT TENURE
            </span>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white">
            What is the maximum and minimum{" "}
            <span className="text-[#7BC4E0]">repayment period</span> at
            Salarymates?
          </h2>

          <p className="text-[#CCE6F5] leading-relaxed text-lg">
            Repayment timelines aren't one-size-fits-all, so we build in room
            to breathe. Depending on your loan, your repayment window can be
            as short as
            <strong className="text-[#7BC4E0]"> 7 days</strong> or run up to
            <strong className="text-[#7BC4E0]"> 45 days</strong>, so you're
            never rushed into a corner.
          </p>
        </div>

        <style jsx>{`
          @keyframes pulse {
            0%,
            100% {
              opacity: 0.5;
              transform: scale(1);
            }
            50% {
              opacity: 0.8;
              transform: scale(1.05);
            }
          }
          .animate-pulse {
            animation: pulse 2s ease-in-out infinite;
          }
        `}</style>
      </div>
    </div>
  );
}
